/**
 * 认证 API 模块
 *
 * 对接后端 /api/auth/* 接口
 */
import request from '../utils/request'
import type { ApiResult } from '../utils/request'

// ===== DTO =====
export interface LoginDTO {
  username: string
  password: string
}

// ===== 后端 SysUser 结构 =====
export interface SysUser {
  id: string | number
  username: string
  realName: string
  avatar: string | null
  phone: string | null
  role: string
  status: number
}

// ===== 登录响应 =====
export interface LoginResult {
  token: string
  user: SysUser
}

/**
 * 用户登录
 */
export function loginApi(data: LoginDTO): Promise<ApiResult<LoginResult>> {
  return request.post('/auth/login', data)
}

/**
 * 用户登出
 */
export function logoutApi(): Promise<ApiResult<void>> {
  return request.post('/auth/logout')
}

/**
 * 获取当前登录用户信息（用于刷新页面后恢复登录态）
 */
export function getUserInfoApi(): Promise<ApiResult<SysUser>> {
  return request.get('/auth/info')
}
